import { api } from '@services';

import Manufacturer, {
  IManufacturer,
  IManufacturerApiModel,
} from '@models/Manufacturer.model';

interface INewManufacturer {
  isTemp?: boolean;
  name: string;
}
interface IManufacturerVariables {
  data: INewManufacturer;
}

const createManufacturer = async ({
  data,
}: IManufacturerVariables): Promise<IManufacturer> => {
  // Always that user create a new product using the Beam Ui, will be Temporary
  data.isTemp = true;
  const { data: manufacture } = await api.post<IManufacturerApiModel>(
    `/manufacturers/`,
    data,
  );

  return Manufacturer.fromApiModel(manufacture);
};

export { createManufacturer };
